import { Col, Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import React from "react";
import premiumIcon from "../../assets/premiumIcon.svg";
import "./style.css";
import { ModalService } from "shared_components";
import { browserHistory } from "react-router";

export default class PremiumCTA extends React.Component {
  static propTypes = {
    phrase: PropTypes.element.isRequired,
    isOrder: PropTypes.bool.isRequired
  };

  state = {
    loading: true
  };

  componentDidMount() {
    this.setState({ loading: false });
  }

  close = () => {
    ModalService.closeCTAPremiumModal();
  };

  redirectToPlanUpgrades = () => {
    this.close();
    browserHistory.push("/settings/plan");
  };

  /*===============================
  =            Renders            =
  ===============================*/
  render() {
    return (
      <Modal
        animation={false}
        bsSize="lg"
        enforceFocus={false}
        backdropClassName="premium__backdrop"
        dialogClassName="premium__dialog"
        keyboard={true}
        onHide={this.close}
        show={true}
      >
        <Modal.Body>{this.renderMainSection()}</Modal.Body>
      </Modal>
    );
  }

  renderUpgradeButton = () => {
    let text = "Upgrade NOW";
    if (this.props.isOrder) {
      text = "Upgrade NOW to Process Orders";
    }

    return (
      <Col md={4} mdOffset={4} className="mt-20">
        <button
          onClick={() => this.redirectToPlanUpgrades()}
          className={"btn btn-block premium__cta-btn"}
        >
          {text}
        </button>
      </Col>
    );
  };

  /**
   * Render the main section of the CTA
   * @return {ReactElement}
   */
  renderMainSection() {
    return (
      <section>
        <Col md={12} className="premium__main-content">
          <span onClick={this.close} className="premium__close-btn">
            ×
          </span>
          <Col md={4} mdOffset={4} className="text-center">
            <h3>
              Premium Products{" "}
              <img className="premium__icon" src={premiumIcon} alt="premium" />
            </h3>
          </Col>
          <Col
            md={10}
            mdOffset={1}
            className="mt-10 premium__content text-center"
          >
            {this.props.phrase}
          </Col>
          <Col md={6} mdOffset={3} className="mt-10 premium__content">
            <ul>
              <li>Best selling, exclusive products</li>
              <li>Highly discounted</li>
              <li>Fast shipping</li>
            </ul>
          </Col>
          {this.renderUpgradeButton()}
        </Col>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PremiumCTA/index.js